// extracted by mini-css-extract-plugin
export default {"InputPair":"InputPair_InputPair__mIMqI"};